import * as Yup from 'yup';

export default Yup.object({
  pin: Yup.string()
    .matches(/^\d{4}$/, 'Die PIN muss aus 4 Ziffern bestehen.')
    .required('Bitte geben Sie Ihren PIN ein.'),
});
